var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.748 3.60498C14.5017 3.60498 14.3013 3.8054 14.3013 4.05168C14.3013 4.29796 14.5017 4.49839 14.748 4.49839C14.9943 4.49839 15.1947 4.298 15.1947 4.05168C15.1947 3.80537 14.9943 3.60498 14.748 3.60498Z",
    fill: "#CDCFD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39962 5.43994C7.21599 5.43994 5.43945 7.21647 5.43945 9.40011C5.43945 11.5837 7.21599 13.3603 9.39962 13.3603C11.5833 13.3603 13.3598 11.5838 13.3598 9.40014C13.3598 7.21651 11.5833 5.43994 9.39962 5.43994Z",
    fill: "#CDCFD0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5559 0.200195H5.24403C2.46272 0.200195 0.199951 2.46296 0.199951 5.24431V13.5561C0.199951 16.3375 2.46272 18.6002 5.24403 18.6002H13.5559C16.3372 18.6002 18.5999 16.3374 18.5999 13.5561V5.24431C18.5999 2.46296 16.3372 0.200195 13.5559 0.200195ZM9.39995 14.447C6.61713 14.447 4.35321 12.183 4.35321 9.40019C4.35321 6.61737 6.61717 4.35349 9.39995 4.35349C12.1827 4.35349 14.4467 6.61741 14.4467 9.40019C14.4467 12.183 12.1827 14.447 9.39995 14.447ZM14.7486 5.58493C13.9031 5.58493 13.2153 4.89708 13.2153 4.05162C13.2153 3.20615 13.9031 2.51827 14.7486 2.51827C15.594 2.51827 16.2819 3.20612 16.2819 4.05158C16.2819 4.89705 15.594 5.58493 14.7486 5.58493Z",
    fill: "#CDCFD0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.ce1b068d.svg";
export { ForwardRef as ReactComponent };